const state = {
	selectedStatuses: [],
	selectedSorting: 'management_lastModifiedDate',
	selectedOrder: 'desc',
};

const getters = {
	getSelectedStatuses(state) {
		return state.selectedStatuses
	},
	getSelectedSorting(state) {
		return state.selectedSorting;
	},
	getSelectedSortOrder(state) {
		return state.selectedOrder;
	}
};

const actions = {
	changeSelectedStatuses({ commit, state }, payload) {
		if (state.selectedStatuses.includes(payload)) {
			commit('removeStatus', state.selectedStatuses.indexOf(payload))
		} else {
			commit('addStatus', payload);
		}
	},
	syncManagementFiltersStore({commit}) {
		let selectedStatuses = localStorage.getItem('selectedStatuses');
		if (selectedStatuses) {
			commit('addMultipleStatuses', selectedStatuses);
		}
	},
	changeSorting({commit}, payload) {
		commit('changeSorting', payload);
	}
};

const mutations = {
	addStatus(state, payload) {
		state.selectedStatuses = [];
		state.selectedStatuses.push(payload);
		localStorage.setItem('selectedStatuses', state.selectedStatuses)
	},
	addMultipleStatuses(state, payload) {
		let arr = payload.split(',').map(function (x) {
			return parseInt(x);
		});

		state.selectedStatuses.push(...arr);
	},
	removeStatus(state, payload) {
		state.selectedStatuses.splice(payload, 1)
		localStorage.setItem('selectedStatuses', state.selectedStatuses)
	},
	changeSorting(state, payload) {
		if(payload.indexOf('_desc') !== -1){
			state.selectedOrder = 'desc';
			payload = payload.replace('_desc', '');
		}else{
			state.selectedOrder = 'asc';
			payload = payload.replace('_asc', '');
		}
		state.selectedSorting = payload;
	}
};
export default { state, getters, actions, mutations };
